import React, { useEffect, useState } from "react";
import { NavigateFunction, useLocation } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { getRecoil, setRecoil } from "recoil-nexus";
import styled from "styled-components";
import CustomToggle from "../../../components/CustomToggle";
import DropdownSelect from "../../../components/DropdownSelect";
import ApiController from "../../../controller/ApiController";
import OrderController from "../../../controller/OrderController";
import StoreController from "../../../controller/StoreController";
import {
  CurrentStoreType,
  authState,
  authStoreListState,
  authStoreType,
  authType,
  currentStoreState,
} from "../../../recoil/auth";
import { OrderItemType } from "../../../recoil/type";
import { urlState } from "../../../recoil/url";
import AsyncLocalStorage from "../../../utils/AsyncLocalStorage";
import {
  completeOrderState,
  notCompleteOrderState,
} from "../../socket/socketState";
import { noticeState } from "../../../recoil/notice";
import LogController from "../../../controller/LogController";
import CheckAutoConfirmModal from "../../../components/modal/CheckAutoConfirmModal";

const minuteList: any = [];
for (let i = 3; i < 19; i++) {
  minuteList.push({
    key: i,
    value: i * 5,
    name: i > 1 ? `${i * 5}분` : `0${i * 5}분`,
  });
}

const SideBar = (oProps: {
  setIsOpenBar: React.Dispatch<React.SetStateAction<boolean>>;
  isOpenBar: boolean;
  viewAvailableToggle: () => void;
  navigate: NavigateFunction;
  refreshAllOrder: (isComplete: number, bPlaySoundOnce?: boolean) => void;
  preparedList: OrderItemType[];
  isLoggedIn: boolean;
}) => {
  // const [url, setUrl] = useState<string>("");
  // let newWindow: any = null;
  // const openNewWindow = (url: string) => {
  //   setUrl(url);
  //   newWindow = window.open(
  //     "http://192.168.168.57:3000",
  //     "_blank",
  //     "width: 200, height: 200"
  //   );
  //   // if (newWindow) {
  //   //   setTimeout(() => {
  //   //     newWindow.postMessage(
  //   //       JSON.stringify({
  //   //         link: url,
  //   //         data: oProps.auth,
  //   //       }),
  //   //       "http://192.168.168.57:3000"
  //   //     );
  //   //   }, 100);
  //   //   // console.log(JSON.stringify(oProps.auth));
  //   // } else {
  //   //   alert("팝업 차단");
  //   // }
  // };

  const [auth, setAuth] = useRecoilState<authType>(authState);
  const [url, setUrl] = useRecoilState<string | null>(urlState);
  // const [storeList, setStoreList] = useState<any>([]);

  const storeList = useRecoilValue<authStoreType[]>(authStoreListState);

  const [currentStore, setCurrentStore] =
    useRecoilState<CurrentStoreType>(currentStoreState);

  const [minute, setMinute] = useState<any>();
  const location = useLocation();

  const [visibleGuide, setVisibleGuide] = useState<boolean>(false);
  const [visibleCheckAutoConfirm, setVisibleCheckAutoConfirm] =
    useState<boolean>(false);

  const set_newLink = (value: string) => {
    if (url === null) {
      setUrl(value);
    }
  };

  const onChange_minute = (event: any) => {
    setMinute(event);
    updateDeliveryInfo(event.value);
  };

  const openPrinterPage = () => {
    if (window && window.parent) {
      window.parent.postMessage(
        JSON.stringify({
          action: "open_printer_settings",
          data: "",
        }),
        "*"
      );
      oProps.setIsOpenBar(false);
      LogController.click({
        path: "Printer setting button",
        params: "프린터설정 클릭",
        params2: "",
      });
    }
  };

  const openDeliverySettingsModal = (e: any) => {
    e.preventDefault();
    oProps.setIsOpenBar(false);
    oProps.navigate("/delivery", { state: { background: location } });
    LogController.click({
      path: "Delivery setting button",
      params: "배달설정 클릭",
      params2: "",
    });
  };

  const setAutoConfirmed = async () => {
    try {
      if (currentStore.value) {
        let iAutoStatus = currentStore.value.auto_confirmed === 1 ? 0 : 1;
        const oRes = await StoreController.setAutoConfirmed(
          currentStore.value.store_id,
          iAutoStatus === 1
        );

        if (oRes) {
          let oAutoToggle: any = JSON.parse(JSON.stringify(currentStore));
          oAutoToggle.value.auto_confirmed = iAutoStatus;
          setCurrentStore(oAutoToggle);
          setRecoil(authState, {
            ...getRecoil(authState),
            store_list: storeList.map((item) =>
              currentStore.value &&
              item.store_id === currentStore.value.store_id
                ? { ...item, auto_confirmed: iAutoStatus }
                : item
            ),
          });
          LogController.click({
            path: "자동주문접수 변경",
            params: iAutoStatus === 1 ? "ON" : "OFF",
            params2: "",
          });
        }
      }
    } catch (err) {
      console.log("err => ", err);
    }
  };

  const setPause = async () => {
    try {
      if (currentStore.value) {
        let iPauseStatus = currentStore.value.pause === 1 ? 0 : 1;
        const oRes = await ApiController.store.setPause(
          currentStore.value.store_id,
          iPauseStatus
        );
        //console.log('iPauseStatus', iPauseStatus);
        if (oRes) {
          let oPausToggle: any = JSON.parse(JSON.stringify(currentStore));
          oPausToggle.value.pause = iPauseStatus;
          setCurrentStore(oPausToggle);
          setRecoil(authState, {
            ...getRecoil(authState),
            store_list: storeList.map((item) =>
              currentStore.value &&
              item.store_id === currentStore.value.store_id
                ? { ...item, pause: iPauseStatus }
                : item
            ),
          });
          LogController.click({
            path: "영업 상태 변경",
            params: iPauseStatus === 1 ? "영업중" : "일시정지",
            params2: "",
          });
        }
      }
    } catch (err) {
      console.log("err => ", err);
    }
  };

  const getStoreDeliveryInfo = async () => {
    try {
      if (currentStore.value) {
        const oRes = await StoreController.getPosStoreData(
          currentStore.value.store_id
        );

        if (oRes && oRes.data && oRes.data.data) {
          //console.log("getPosStoreData", oRes.data);
          setMinute({
            key: -1,
            value: oRes.data.data.delivery_estimated_time,
            name: `${oRes.data.data.delivery_estimated_time}분`,
          });
        }
      }
    } catch (err) {
      console.log("err => ", err);
    }
  };

  const updateDeliveryInfo = async (minutes: number) => {
    try {
      if (currentStore.value) {
        let oRes = await OrderController.updateDeliveryInfo(
          currentStore.value.store_id,
          minutes
        );
        console.log("updateDeliveryInfo", oRes, minutes);
        if (oRes && oRes.data && oRes.data.ok) {
          oProps.refreshAllOrder(2, true);
          LogController.click({
            path: "전체 배달시간 변경",
            params: minutes.toString(),
            params2: "",
          });
        }
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  const userLogout = async () => {
    LogController.click({
      path: "로그아웃",
      params: "",
      params2: "",
    });
    //console.log("userLogout");
    let oLogoutData: any = "";
    setRecoil(authState, oLogoutData);
    setRecoil(completeOrderState, {
      date: new Date().getTime().toString(),
      order_status: 0,
      is_update: false,
    });
    setRecoil(notCompleteOrderState, {
      date: new Date().getTime().toString(),
      order_status: 0,
      order_id: "",
      user_token_id: 0,
      is_update: false,
      is_print: false,
    });
    await AsyncLocalStorage.removeItem("auth");
    await AsyncLocalStorage.removeItem("webBrowserLogin");
    setAuth(oLogoutData);
    if (window && window.parent) {
      window.parent.postMessage(
        JSON.stringify({
          action: "logout_user",
          data: "",
        }),
        "*"
      );
    }
  };

  const getStoreList = async () => {
    if (auth) {
      const res = await ApiController.auth.getStoreList(auth.user_id);
      if (res && res.data && res.data.data) {
        const storeTemp = res.data.data;

        if (currentStore.value) {
          const filteredStore = storeList.find(
            (item) => item.store_id === currentStore.value?.store_id
          );
          if (filteredStore) {
            setCurrentStore({
              name: filteredStore.store_name,
              value: filteredStore,
            });
            //console.log("storeList", storeList);
          } else {
            if (storeList && storeList.length > 0) {
              setCurrentStore({
                name: storeList[0].store_name,
                value: storeList[0],
              });
            }
          }
        } else {
          //setCurrentStore(storeTemp[0]);
          if (storeTemp && storeTemp.length > 0) {
            let oStore: any = {
              value: storeTemp[0],
            };
            setCurrentStore(oStore);
          }
        }
      }
      // const storeTemp: any[] = storeList;
    }
  };

  const openGuide = () => {
    if (!visibleGuide) {
      setVisibleGuide(true);
    }
  };

  const ActiveConfirm = () => {
    setVisibleCheckAutoConfirm(false);
    setAutoConfirmed();
  };

  useEffect(() => {
    //console.log("start", auth);
    if (oProps.isLoggedIn) {
      getStoreList();
    }
  }, [auth, oProps.isLoggedIn]);

  useEffect(() => {
    if (currentStore.value && oProps.isLoggedIn) {
      getStoreDeliveryInfo();
    }
  }, [currentStore, oProps.isLoggedIn]);

  useEffect(() => {
    setVisibleGuide(false);
  }, [oProps.isOpenBar]);

  useEffect(() => {
    if (visibleGuide) {
      setTimeout(() => {
        setVisibleGuide(false);
      }, 3000);
    }
  }, [visibleGuide]);

  return (
    <>
      <Style>
        <div className={oProps.isOpenBar ? "sideBar active" : "sideBar"}>
          <div className="siderBarHeader">
            <div className="logoButton">
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_knock_wide_logo.svg`}
                alt="ic"
              />
            </div>
          </div>
          <div className="siderBarContent">
            {currentStore && (
              <RenderCurrentStore
                currentStore={currentStore}
                setCurrentStore={setCurrentStore}
                minute={minute}
                onChange_minute={onChange_minute}
                setPause={setPause}
                setAutoConfirmed={setAutoConfirmed}
                storeList={storeList}
                setVisibleCheckAutoConfirm={setVisibleCheckAutoConfirm}
              />
            )}
            <div className="sideBarList">
              {/* <div className="sideBarItem">
              <h3>노크노크 광고설정</h3>
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_right_black.svg`}
                alt="닫기"
              />
            </div> */}
              <div className="sideBarItem" onClick={openDeliverySettingsModal}>
                <h3>배달설정</h3>
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_right_black.svg`}
                  alt="닫기"
                />
              </div>
              {/* <div
                className="sideBarItem"
                onClick={() => set_newLink("product")}
              >
                <h3>상품관리</h3>
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_right_black.svg`}
                  alt="닫기"
                />
              </div>

              <div
                className="sideBarItem"
                onClick={() => set_newLink("settle")}
              >
                <h3>매출조회</h3>
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_right_black.svg`}
                  alt="닫기"
                />
              </div> */}

              <div className="sideBarItem" onClick={openPrinterPage}>
                <h3>프린트 설정</h3>
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_right_black.svg`}
                  alt="닫기"
                />
              </div>
              <div
                className="sideBarItem"
                onClick={() =>
                  // set_newLink("notice")
                  setRecoil(noticeState, true)
                }
              >
                <h3>공지사항</h3>
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_right_black.svg`}
                  alt="닫기"
                />
              </div>
              <div className="manageButtonWrap">
                <button onClick={() => set_newLink("main")}>
                  <div>
                    <h4>스토어매니저</h4>
                    <p>관리자페이지로 이동</p>
                  </div>
                  <img
                    src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_right.svg`}
                    alt="닫기"
                  />
                </button>
              </div>
            </div>
          </div>
          <div className="footer">
            <div className="row">
              <h4>중개수수료 및 광고료 안내</h4>
              <div className="guideWrap">
                <img
                  onClick={openGuide}
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_question.svg`}
                  alt="question"
                />
                {visibleGuide && (
                  <div className="guideBox">
                    <h4>• 중개수수료: 6.8%</h4>
                    <h4>• 광고료: 객실 기기 200개 기준 월 9만원</h4>
                  </div>
                )}
              </div>
            </div>
            <button className="row" onClick={userLogout}>
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_logout.svg`}
                alt="로그아웃"
              />
              <h3>로그아웃</h3>
            </button>
            <p className="version">v 1.2.1</p>
          </div>
        </div>
      </Style>
      <CheckAutoConfirmModal
        isVisible={visibleCheckAutoConfirm}
        setVisible={setVisibleCheckAutoConfirm}
        onConfirm={ActiveConfirm}
      />
    </>
  );
};

const RenderCurrentStore = (oProps: any) => {
  const [aDropDownStore, set_aDropDownStore] = useState<any>();
  const [visibleGuide, setVisibleGuide] = useState<boolean>(false);

  const setStoreList = () => {
    let aDropDownStore: any = [];
    const storeTemp: any[] = oProps.storeList;
    if (storeTemp && storeTemp.length > 0) {
      storeTemp.map((item) => {
        aDropDownStore.push({
          key: item.store_id,
          name: item.store_name,
          value: item,
        });
      });
      set_aDropDownStore(aDropDownStore);
    }
  };

  const openGuide = () => {
    if (!visibleGuide) {
      setVisibleGuide(true);
    }
  };

  const openAutoConfirmCheck = () => {
    if (oProps.currentStore.value) {
      console.log(
        "oProps.currentStore.value.auto_confirmed",
        oProps.currentStore.value.auto_confirmed
      );
      if (oProps.currentStore.value.auto_confirmed === 0) {
        oProps.setVisibleCheckAutoConfirm(true);
      } else {
        oProps.setAutoConfirmed();
      }
    }
  };

  useEffect(() => {
    setStoreList();
  }, []);

  useEffect(() => {
    if (oProps.currentStore) {
      setStoreList();
    }
  }, [oProps.currentStore]);

  useEffect(() => {
    setStoreList();
  }, [oProps.storeList]);

  useEffect(() => {
    if (visibleGuide) {
      setTimeout(() => {
        setVisibleGuide(false);
      }, 3000);
    }
  }, [visibleGuide]);

  return (
    oProps.currentStore.value &&
    aDropDownStore &&
    aDropDownStore.length > 0 && (
      <>
        <div className="sideBarTitle">
          <DropdownSelect
            options={aDropDownStore}
            defaultValue={{
              key: oProps.currentStore.value.store_id,
              name: oProps.currentStore.value.store_name,
              value: oProps.currentStore.value,
            }}
            onChangeValue={(e: any) => {
              oProps.setCurrentStore(e);
              LogController.click({
                path: "현재 매장 변경",
                params: e.value,
                params2: e.name,
              });
            }}
          />
        </div>
        {oProps.minute && (
          <DropdownSelect
            options={minuteList}
            defaultValue={oProps.minute}
            onChangeValue={oProps.onChange_minute}
          />
        )}

        <div className="toggle">
          <button
            className={`toggleItem left ${
              oProps.currentStore.value.pause === 0 && "active"
            }`}
            onClick={oProps.setPause}
          >
            <div
              className={`loadingDots ${
                oProps.currentStore.value.pause === 0 && "active"
              }`}
            >
              <div className="dot" />
              <div className="dot" />
              <div className="dot" />
            </div>
            영업중
          </button>
          <button
            className={`toggleItem right ${
              oProps.currentStore.value.pause === 1 && "active"
            }`}
            onClick={oProps.setPause}
          >
            <img
              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_pause${
                oProps.currentStore.value.pause === 1 ? "" : "_grey"
              }.svg`}
              alt="ic"
            />
            일시정지
          </button>
        </div>
        <div className="toggleListWrap">
          <div className="between">
            <div className="row">
              <h3>자동 주문접수</h3>
              <div className="guideWrap">
                <img
                  onClick={openGuide}
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_question.svg`}
                  alt="question"
                />
                {visibleGuide && (
                  <div className="guideBox bottom">
                    <h5>설정한 준비시간으로 주문이 자동접수됩니다.</h5>
                  </div>
                )}
              </div>
            </div>
            <CustomToggle
              toggleItem={oProps.currentStore.value.auto_confirmed === 1}
              onChange={openAutoConfirmCheck}
              activeColor={"#4dd2ae"}
            />
          </div>
        </div>
      </>
    )
  );
};

export default SideBar;

const Style = styled.div`
  .toggle {
    display: flex;
    align-items: center;
    border-radius: 5px;
    background: #ffffff;
    white-space: nowrap;
    .toggleItem {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      width: 120px;
      height: 50px;
      padding: 6px 0;
      background-color: #fff;
      color: #adadad;
      font-size: 12px;
      font-weight: 600;
      border: 1px solid #d2d2d2;
    }
    .toggleItem.left.active {
      background: #4dd2ae;
      color: #ffffff;
      border: 1px solid #4dd2ae;
    }
    .toggleItem.left {
      border-right: none;
      border-radius: 5px 0 0 5px;
    }
    .toggleItem.right.active {
      background: #ff3542;
      color: #ffffff;
      border: 1px solid #ff3542;
    }
    .toggleItem.right {
      border-left: none;
      border-radius: 0 5px 5px 0;
    }

    .loadingDots {
      height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      .dot {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: #adadad;
      }
    }
    .loadingDots.active {
      @keyframes bounce {
        20%,
        50%,
        80%,
        100% {
          transform: scale(1);
        }
        40% {
          transform: scale(1.5);
        }
      }
      .dot {
        background-color: #ffffff;
        animation: bounce 2s infinite;
      }
      .dot:nth-child(2) {
        animation-delay: 0.5s;
      }
      .dot:nth-child(3) {
        animation-delay: 1s;
      }
    }
  }

  .sideBar {
    display: block;
    position: fixed;
    top: 0;
    left: -25%;
    width: 25%;
    max-width: 300px;
    height: 100%;
    z-index: 999;
    background: #ffffff;
    border-right: 1px solid #d9d9d9;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    animation: width 0.2s ease-in-out;
    transition: all 0.2s;

    .siderBarHeader {
      display: flex;
      min-height: 40px;
      height: 40px;
      .logoButton {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #ffffff;
      }
    }
    .siderBarContent {
      width: 100%;
      height: 100%;
      padding: 6% 10%;
      display: flex;
      flex-direction: column;

      .selector {
        /* max-width: 120px; */
        margin: 1px;
        padding: 10px 0;
        background: #fff;
        border: 1px solid #d2d2d2;
        font-weight: 600;
        color: #515151;
        border-radius: 5px;
        margin-bottom: 10px;
        .selectHeader {
          margin: -1px;
          padding-left: 16px;
          h2 {
            font-size: 18px;
            font-weight: 600;
            text-align: left;
            color: #000000;
          }
        }
        .selectList {
          max-width: 100%;
          border-color: #d2d2d2;
          box-shadow: none;
          .selectItem {
            padding-left: 16px;
            text-align: left;
          }
        }
      }
    }

    h3 {
      font-size: 16px;
      line-height: 24px;
      font-weight: 600;
      color: #333333;
    }

    .sideBarList {
      flex: 1;
      padding-top: 10px;
      display: flex;
      flex-direction: column;
      gap: 20px;
      .sideBarItem {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 4% 0;
        cursor: pointer;
      }
    }
  }

  .sideBar.active {
    left: 0;
  }

  .footer {
    display: flex;
    flex-direction: column;
    gap: 14px;
    padding-left: 10%;
    padding-bottom: 8%;
  }

  .row {
    display: flex;
    align-items: center;
    padding: 0;
    gap: 8px;
    h3 {
      font-weight: 500;
    }
    h4 {
      font-size: 14px;
      font-weight: 500;
      color: #6d6d6d;
    }
    .guideWrap {
      display: flex;
      align-items: center;
      position: relative;
    }
    .guideBox {
      top: -30px;
      left: 24px;
      position: absolute;
      padding: 12px;
      border-radius: 10px;
      background: #efefef;
      h4 {
        line-height: 28px;
        font-weight: 500;
        color: #555555;
        white-space: nowrap;
      }
      h5 {
        white-space: nowrap;
      }
    }
    .guideBox.bottom {
      top: 28px;
      left: -125px;
    }
  }

  ::-webkit-scrollbar {
    display: none;
  }

  .toggleListWrap {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin: 6% 0;
    gap: 8px;
    .between {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    h3 {
      color: #333333;
      font-weight: 500;
    }
    h4 {
      color: #333333;
      font-weight: 500;
    }
    h5 {
      color: #333333;
    }
  }

  .version {
    position: absolute;
    right: 16px;
    bottom: 16px;
    font-size: 14px;
    color: #cecece;
    font-weight: 500;
  }

  .manageButtonWrap {
    border-top: 1px solid #cecece;
    padding-top: 30px;
    display: flex;
    flex-direction: column;
    width: 100%;
    button {
      margin-right: -4px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 6px 4px 6px 14px;
      background-color: #4dd2ae;
      border-radius: 5px;
      h4 {
        font-size: 16px;
        line-height: 24px;
        color: #fff;
        font-weight: 600;
        text-align: left;
      }
      p {
        font-size: 12px;
        color: #fff;
        font-weight: 500;
      }
      img {
        width: 20px;
        height: 20px;
      }
    }
  }
`;
